// extracted by mini-css-extract-plugin
export var root = "markdown-text-module--root--FT5yl";